import NiceSelect from "nice-select2/dist/js/nice-select2";

new NiceSelect(document.getElementById("currency"));
const selectElements = document.querySelectorAll('.select');
selectElements.forEach(function (selectElement) {
    new NiceSelect(selectElement);
});

document.addEventListener('DOMContentLoaded', function() {
    scrolledPage();
    secondaryNav();
    cloneSearchInput();
    calculateVisibleHeights();
    readMore();
});
window.addEventListener('scroll', function() {
    scrolledPage();
    calculateVisibleHeights();
});
window.addEventListener('resize', function() {
    calculateVisibleHeights();
});

//search BY id focus effect
function searchInputNav(form) {
    const searchInput = document.querySelector('.header-search-input');
    const searchContainer = document.querySelector('.header-search');
    const resetButton = document.querySelector('.header-search-reset');


    // Add event listener for focus event
    searchInput.addEventListener('focus', function() {
        searchContainer.classList.add('focus');
    });

    // Add event listener for blur event
    searchInput.addEventListener('blur', function() {
        searchContainer.classList.remove('focus');
    });

    searchInput.addEventListener('input', function() {
        // Check if the input is not empty and adjust the opacity
        if(searchInput.value.trim() !== '') {
            resetButton.style.opacity = 1;
        } else {
            resetButton.style.opacity = 0;
        }
    });
    // Clear input when reset button is clicked
    resetButton.addEventListener('click', function() {
        searchInput.value = '';
        resetButton.style.opacity = 0;
        searchInput.focus();
    });
}
function cloneSearchInput(){
    // Attach event listener to original form
    const originalForm = document.getElementById('search-by-id');
    // Check if the form exists
    if (originalForm) {
        searchInputNav(originalForm);

        // Clone the form
        const clonedForm = originalForm.cloneNode(true);
        // Since IDs should be unique, remove the ID from the cloned form
        clonedForm.removeAttribute('id');
        // Re-attach the event listener to the cloned form
        searchInputNav(clonedForm);

        // Append the cloned form to the clone container
        document.getElementById('clone-search').appendChild(clonedForm);
    }
}

// Navigation variables
const navToggle = document.querySelector('.nav-toggle');
const closeBtn = document.querySelector('.close-btn');
const closeNav = document.querySelector('.close-nav');
const showBtn = document.querySelector('.show-btn');
const navList = document.querySelector('.sidebar-nav');
let scrollEnabled = true;
let scrollPosition = 0;

function toggleNavigation() {
    scrollFunctionality();

    // Determine the current state and toggle the navigation visibility accordingly
    const isNavHidden = navList.classList.contains('hidden');
    navToggle.setAttribute('aria-expanded', isNavHidden ? 'true' : 'false');
    closeNav.setAttribute('aria-expanded', isNavHidden ? 'true' : 'false'); // If needed

    // Toggle classes based on navigation visibility
    navList.classList.toggle('hidden', !isNavHidden);
    closeBtn.classList.toggle('hidden', !isNavHidden);
    showBtn.classList.toggle('hidden', isNavHidden);
}

// Event listeners for toggling the navigation
navToggle.addEventListener('click', toggleNavigation);
closeNav.addEventListener('click', toggleNavigation);

document.addEventListener('keydown', (event) => {
    // Close menu with ESC key
    if (event.keyCode === 27) {
        if (!navList.classList.contains('hidden')) {
            scrollFunctionality();
            navToggle.setAttribute('aria-expanded', 'false');
            navList.classList.add('hidden');
            closeBtn.classList.add('hidden');
            showBtn.classList.remove('hidden');
        }
    }
});

function scrollFunctionality(){
    // Toggle disable scroll
    scrollEnabled = !scrollEnabled;

    if (!scrollEnabled) {
        disableScroll();
    } else {
        enableScroll();
    }
}

function disableScroll() {
    scrollPosition = window.pageYOffset;
    window.addEventListener('scroll', preventScroll);
}

function enableScroll() {
    window.removeEventListener('scroll', preventScroll);
}

function preventScroll(e) {
    window.scrollTo(0, scrollPosition);
}


// Secondary nav toggle hidden class
function secondaryNav() {
    const activeLinks = document.querySelectorAll('.sidebar-nav-link-active');

    activeLinks.forEach(function(link) {
        link.addEventListener('click', function() {
            const nextNav = this.nextElementSibling;
            nextNav.classList.toggle('hidden');
            this.classList.toggle('open');

            activeLinks.forEach(function(otherLink) {
                if (otherLink !== link) {
                    otherLink.classList.remove('open');
                    if (otherLink.nextElementSibling) {
                        otherLink.nextElementSibling.classList.add('hidden');
                    }
                }
            });
        });
    });
}

function scrolledPage() {
    if (window.scrollY >= 80) {
        document.body.classList.add('scrolled');
    } else {
        document.body.classList.remove('scrolled');
    }
}

function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    );
}

function calculateVisibleHeights() {
    const middleNav = document.getElementById('middle-nav');
    let totalHeight = 0;

    const rect = middleNav.getBoundingClientRect();
    if (rect.top === 0) {
        totalHeight = middleNav.offsetHeight;
    } else {
        const ids = ['top-nav', 'middle-nav', 'bottom-nav'];
        ids.forEach(id => {
            const element = document.getElementById(id);
            if (element && isInViewport(element)) {
                totalHeight += element.offsetHeight;
            }
        });
    }

    const sidebarNav = document.querySelector('.sidebar-nav');
    if (sidebarNav) {
        sidebarNav.style.top = `${totalHeight}px`;
    }

    return totalHeight;
}


function readMore() {
    const descriptionElements = document.querySelectorAll('.more-text'); // Multiple elements

    if(descriptionElements) {
        descriptionElements.forEach((descriptionElement) => {
            // Read the max height from data attribute. Use a default value if not set.
            const maxDescriptionHeight = parseInt(descriptionElement.getAttribute('data-max-height'), 10) || 258;

            const toggleBtn = descriptionElement.nextElementSibling; // We assume the toggleBtn is the next sibling
            const hideBtn = toggleBtn.nextElementSibling; // We assume the hideBtn is two elements after

            // Initially hide the hideBtn
            hideBtn.classList.add('hidden');

            // Check if content exceeds maximum height
            if (descriptionElement.scrollHeight > maxDescriptionHeight) {
                toggleBtn.classList.remove('hidden');
                descriptionElement.style.maxHeight = maxDescriptionHeight + 'px';
                descriptionElement.style.overflow = 'hidden';
            } else {
                // If content doesn't exceed maximum height, hide the toggleBtn
                toggleBtn.classList.add('hidden');
            }

            toggleBtn.addEventListener('click', function () {
                descriptionElement.style.maxHeight = 'none';
                toggleBtn.classList.add('hidden');
                hideBtn.classList.remove('hidden');
            });

            hideBtn.addEventListener('click', function () {
                descriptionElement.style.maxHeight = maxDescriptionHeight + 'px';
                hideBtn.classList.add('hidden');
                toggleBtn.classList.remove('hidden');
            });
        });
    }
}